import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Modal, Switch } from '../../common';
import toast from 'react-hot-toast';
import { getErrorString } from '../../utils';
import { activateClientUser, deactivateClientUser } from '../../reducers/client-users-slice';
import usePermissions from 'hooks/usePermissions/usePermissions';
import { PERMISSIONS_STRUCT } from 'constants/permissions';

const DeactivateUserToggle = ({ row, onSuccess }) => {
  const dispatch = useDispatch();
  const { getPermission } = usePermissions();

  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleToggle = () => {
    if (row?.is_active) {
      setModalOpen(true);
    } else {
      handleActivate();
    }
  };

  const handleActivate = async () => {
    setLoading(true);
    const res = await dispatch(activateClientUser(row?.id));
    if (res?.payload?.status) {
      toast.success('User activated successfully.');
      onSuccess?.();
    } else {
      toast.error(getErrorString(res?.payload));
    }
    setLoading(false);
  };

  const handleDeactivate = async () => {
    setLoading(true);
    const res = await dispatch(deactivateClientUser(row?.id));
    if (res?.payload?.status) {
      toast.success('User deactivated successfully.');
      setModalOpen(false);
      onSuccess?.();
    } else {
      toast.error(getErrorString(res?.payload));
    }
    setLoading(false);
  };

  const renderFooter = () => (
    <Button
      loading={loading}
      onClick={handleDeactivate}
      style={{ height: '48px' }}
      className="primary-button body-semibold red"
    >
      Deactivate user
    </Button>
  );

  const renderBody = () => (
    <div style={{ color: 'var(--user-main-text)' }} className="body-14-medium">
      <strong>Deactivate {row?.name}?</strong>
      {' This will:'}
      <br />
      {'- Revoke their system access'}
      <br />
      {'- Stop all email and text notifications'}
      <br />
      {'- Remove them from all teams'}
      <br />
      {'- Reassign their pending support chat conversations'}
    </div>
  );

  const isButtonDisabled = row?.is_active
    ? !getPermission({
        models: PERMISSIONS_STRUCT.USER.NAME,
        actions: PERMISSIONS_STRUCT.USER.ACTIONS.DEACTIVATE_ACCOUNT,
      })
    : !getPermission({
        models: PERMISSIONS_STRUCT.USER.NAME,
        actions: PERMISSIONS_STRUCT.USER.ACTIONS.ACTIVATE_ACCOUNT,
      });

  return (
    <>
      <Switch checked={row?.is_active} disabled={isButtonDisabled} loading={loading} handleChange={handleToggle} />
      <Modal
        title="Deactivate User"
        open={modalOpen}
        ModalBody={renderBody()}
        handleCancel={() => setModalOpen(false)}
        customFooter={renderFooter()}
        showCustomFooter
        width={550}
        destroyOnClose
      />
    </>
  );
};

export default DeactivateUserToggle;
